import {
  DEFAULT_MIN_DATE_RANGE,
  DEFAULT_MAX_DATE_RANGE,
} from 'constants/constants';
import dayjs from 'dayjs';

export const customerViewInitialState = {
  saveInsightViewBtnState: true,
  allInsightViews: [],
  selectedInsightView: {},
  defaultCustomerType: [],
  priorityCustomers: [],
  allCustomers: [],
  focusAccountDisabled: false,
  isApply: false,
  selectedCustomer: [],
  advanceSearchSelectedData: {},
  advanceSearchClicked: {},
  selectedView: 'account',
  allAccountOptions: [],
  allSiteOptions: [],
  ecosystemOptions: [],
  productOptions: [],
  allProductOptions: [],
  squadOptions: [],
  allSquadOptions: [],
  timePeriodOptions: [],
  timePeriods: [],
  selectedAccount: [],
  selectedEcosystem: [],
  selectedProduct: [],
  selectedSquad: [],
  selectedTimePeriod: [],

  selectedSiteView: [],

  timePeriodName: 'Oct 21-Sep 22',
  prevFocusAccountChecked: true,
  focusAccountChecked: true,
  focusSiteChecked: true,
  isAccountAvailable: true,
  viewName: 'Gross Sales by Account',
  kpiId: 1,
  kpiName: 'Gross Sales',
  dimensionName: '',
  noDimensionValue: '',
  benchmarkNoDimensionValue: '',
  chartType: 'linechart',
  chartData: [],
  tableData: [],
  cards: [],
  selectedKpiName: '',
  selectedKpi: {},
  showSuccess: false,
  custInsightsBrdId: '',
  insightType: '',
  accountDetails: {},
  insightBoards: [],
  contacts: [],
  crmScores: {},
  crmPercent: {
    nps: 0,
    sat: 0,
    partner: 0,
  },
  beamChart: {},
  beamChartSite: {},
  surveyTotal: {
    nps: '',
    sat: '',
    partner: '',
  },
  uses: null,
  crmQuarter: '',
  affiliated: '',
  selectedAccountId: 0,
  sitePerformanceFilters: {
    Site_Performance_SiteName_Address: {
      options: [],
      selectedValue: [],
    },
    Product: {
      options: [],
      selectedValue: [],
    },
    Ecosystem: {
      options: [],
      selectedValue: [],
    },
    contract_segment_Filter: {
      options: [],
      selectedValue: [],
    },
    SiteSquad: {
      options: [],
      selectedValue: [],
    },
    TimePeriod: {
      options: [],
      selectedValue: {
        value: 'R12',
        label: 'R12M',
      },
    },
    IsAccountableProduct: true,
  },
  policyDetailsFilters: {
    Payer: {
      selectedValue: [],
    },
    Plan: {
      selectedValue: [],
    },
    Product: {
      selectedValue: [],
    },
    Indication: {
      selectedValue: [],
    },
    CompetitorProduct: {
      selectedValue: [],
    },
    EcosystemName: {
      selectedValue: [],
    },
    PolicyState: {
      selectedValue: [],
    },
    BookOfBusiness: {
      selectedValue: [],
    },
    BenefitType: {
      selectedValue: [],
    },
  },
  payerMixFilters: {
    Parent_Payer: {
      selectedValue: [],
    },
    Payer: {
      selectedValue: [],
    },
    Book_Of_Business: {
      selectedValue: [],
    },
    Benifit_Type: {
      selectedValue: [],
    },
    Payer_Mix_Product: {
      selectedValue: [],
    },
    Payer_Indication: {
      selectedValue: [],
    },
    Competitor_Brand: {
      selectedValue: [],
    },
    Payer_Ecosystem: {
      selectedValue: [],
    },
  },
  siteUtilizationFilters: {
    SiteUtilization_Ecosystem: {
      options: [],
      selectedValue: [],
    },
    SiteUtilization_SiteName_Address: {
      options: [],
      selectedValue: [],
    },
    SiteUtilization_SiteCity: {
      options: [],
      selectedValue: [],
    },
    SiteUtilization_SiteState: {
      options: [],
      selectedValue: [],
    },
    SiteUtilization_Site_Address: {
      options: [],
      selectedValue: [],
    },
  },
  configureInsightsFilters: {
    Product: {
      options: [],
      selectedValue: [],
    },
    SiteSquad: {
      options: [],
      selectedValue: [],
    },
    Ecosystem: {
      options: [],
      selectedValue: [],
    },
    SiteName_Address: {
      options: [],
      selectedValue: [],
    },
    IsAccountableProduct: true,
  },

  siteInfoFilters: {
    HCPName: {
      options: [],
      selectedValue: [],
    },
    HCPStakeholderType: {
      options: [],
      selectedValue: [],
    },
    Speciality: {
      options: [],
      selectedValue: [],
    },
    City: {
      options: [],
      selectedValue: [],
    },
    State: {
      options: [],
      selectedValue: [],
    },
    Zip: {
      options: [],
      selectedValue: [],
    },
  },

  affiliationsFilters: {
    SiteName_Address: {
      options: [],
      selectedValue: [],
    },
    SiteState: {
      options: [],
      selectedValue: [],
    },
    SiteHIN: {
      options: [],
      selectedValue: [],
    },
    SiteAddress: {
      options: [],
      selectedValue: [],
    },
    HCPStakeholderTypes: {
      options: [],
      selectedValue: [],
    },
    HCPNames: {
      options: [],
      selectedValue: [],
    },
    HCPAddress: {
      options: [],
      selectedValue: [],
    },
    SiteSpeciality: {
      options: [],
      selectedValue: [],
    },
  },

  productMixFilters: {
    Product: {
      options: [],
      selectedValue: [],
    },
    SiteSquad: {
      options: [],
      selectedValue: [],
    },
    TimePeriod: {
      options: [],
      selectedValue: {
        value: 'R12',
        label: 'R12M',
      },
    },
    IsAccountableProduct: true,
  },
  copayAllEcosystem: [],
  copayAnalyticsFilters: {
    copayEcosystem: {
      selectedValue: [],
    },
    copaySiteAddressName: {
      selectedValue: [],
    },
    copayQuarter: {
      selectedValue: [],
    },
    copayProduct: {
      selectedValue: [],
    },
    copaySquad: {
      selectedValue: [],
    },
  },

  engagementFilters: {
    StakeholderName: {
      options: [],
      selectedValue: [],
    },
    StakeholderType: {
      options: [],
      selectedValue: [],
    },
    Engagement: {
      options: [],
      selectedValue: [],
    },
    Brand: {
      options: [],
      selectedValue: [],
    },
    Squad: {
      options: [],
      selectedValue: [],
    },
    Indication: {
      options: [],
      selectedValue: [],
    },
    GNE_User_Name: {
      options: [],
      selectedValue: [],
    },
    GENE_User_Role: {
      options: [],
      selectedValue: [],
    },
    EngagementEcosystem: {
      options: [],
      selectedValue: [],
    },
    startDate: {
      selectedValue: dayjs().subtract(DEFAULT_MAX_DATE_RANGE, 'day').toDate(),
    },
    endDate: {
      selectedValue: dayjs().subtract(DEFAULT_MIN_DATE_RANGE, 'day').toDate(),
    },
  },
  marketingFilters: {
    Channel: {
      options: [],
      selectedValue: [],
    },
    DiscussionTopic: {
      options: [],
      selectedValue: [],
    },
    PayerStakeholderType: {
      options: [],
      selectedValue: [],
    },

    TemplateName: {
      options: [],
      selectedValue: [],
    },
    SurveyType: {
      options: [],
      selectedValue: [],
    },
    PresentationName: {
      options: [],
      selectedValue: [],
    },
    KeyMessage: {
      options: [],
      selectedValue: [],
    },
  },
  columnsRestiction: {},
  excelColumnsRestiction: [],
  copayCustomColumn: ['Product', 'Site_ID', 'site_zip'],
  affiliationsData: {},
  affiliationsSiteData: {},
  sitePerformanceData: {},
  copayAnalyticsData: {},
  productMixData: {},
  timespan: '',
  hcpFlag: false,
  darwinReportsData: [],
  exportSiteUtilizaztion: false,
  exportAccountpayermix: false,
  exportCopayAnalytics: false,
  exportAffiliation: false,
  exportPolicyDetails: false,
  exportSite: false,
  copayExpression: '',
  appUsers: [],
  notificationEmailStatus: false,
  notifyUsersByEmailList: [],
  advanceOptions: '',
  advanceDropdownOptions: [],
  paymentMethod: '',
  vocAlertFlag: false,
};
